import React from "react";
import { SEVEN_SUMMITS } from "../data/constants";
import countries from "../data/countries";

export default function HomePage({ go }) {
  return (
    <>
      <section className="hero">
        <div className="hb">The Definitive Global Summit Reference</div>
        <h1>The Highest Point<br />in Every Country</h1>
        <p>From the summit of Everest at 8,849m to Maldives at just 5.1m — explore the highest point in every sovereign nation on Earth.</p>
        <div className="hs">
          {[[countries.length, "Countries"], ["7", "Continents"], ["8,849m", "Highest"], ["5.1m", "Lowest"]].map(([n, l]) => (
            <div key={l} style={{ textAlign: "center" }}>
              <div className="hsn">{n}</div>
              <div className="hsl">{l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="ss">
        <div className="si">
          <div className="sec-h"><h2>The Seven Summits</h2><p>The highest peak on each continent</p></div>
          <div className="sg">
            {SEVEN_SUMMITS.map((s) => (
              <div className="sc" key={s.peak} onClick={() => go({ t: "detail", code: s.code })} style={{ cursor: "pointer" }}>
                <div className="scn">{s.continent}</div>
                <div className="scp">{s.peak}</div>
                <div className="sce">{s.elev}</div>
                <div className="scm">{s.country} — <em>{s.note}</em></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: "50px 24px", textAlign: "center" }}>
        <div className="sec-h"><h2>Start Exploring</h2><p>Browse the interactive map or view the rankings</p></div>
        <div style={{ display: "flex", justifyContent: "center", gap: 14, marginTop: 24, flexWrap: "wrap" }}>
          <button className="dl" style={{ fontSize: 14, padding: "12px 24px", background: "var(--ac)", color: "#fff", border: "none" }} onClick={() => go({ t: "guides" })}>▲ Browse Guides</button>
          <button className="dl" style={{ fontSize: 14, padding: "12px 24px" }} onClick={() => go({ t: "ranking" })}>📊 Rankings</button>
        </div>
      </section>
    </>
  );
}
